import {confirmAlert,} from "react-confirm-alert";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useState} from "react";
import Button from "../../../components/UI/Button";
import {deleteCourier} from "../../../api/couriers";

const CourierTableActions = ({row, editRecord}) =>{

  const [toastId, setToastId] = useState(null);

  const queryClient = useQueryClient()

  const {mutate, isPending} = useMutation({
    mutationFn: deleteCourier,
    onMutate: () => {
      setToastId(toast.loading("Please wait..."))
    },
    onSuccess: (response, payload) => {
      toast.update(toastId, { render: "Courier Deleted!", type: "success", isLoading: false, autoClose: true  });
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'couriers',
      });
    },
    onError: () => {
      toast.update(toastId, { render: "Something happened!", type: "error", isLoading: false, autoClose: true });
    }
  })

  const editHandler = ()=>{
    editRecord(row)
  }

  const deleteHandler = () => {
    confirmAlert({
      title: 'Delete',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            mutate({id: row.id})
          },
        },
        {
          label: 'No',
          onClick: () => {
            return;
          },
        }
      ]
    });
  }
  return (
    <>
      <Button
        text="Edit"
        classes={"mr_5"}
        size={'btn_sm'}
        variant={"has_border_radius btn_transparent"}
        onClickHandler={editHandler}
      />
      <Button
        text="Delete"
        variant={"btn_danger"}
        size={'btn_sm'}
        classes={'has_border_radius'}
        isPending={isPending}
        onClickHandler={deleteHandler}
      />
    </>
  );
}

export default CourierTableActions;